/** Backend-owned plugin catalogue; presentation must never decide workspace access. */
import { SUPABASE_URL } from '../utils/supabase/url';
import { getAuthHeaders } from '../utils/supabase/client';

export const WORKSPACE_PLUGINS_CHANGED_EVENT = 'workspace-plugins:changed';

export interface WorkspacePlugin {
  id: string;
  name: string;
  description: string;
  scope: 'personal' | 'workspace';
  enabled: boolean;
  capabilities: { view: boolean; configure: boolean; use: boolean };
  status: 'available' | 'connected';
  tenantName?: string;
  lastSyncAt?: string;
}
export interface WorkspacePluginCatalogue { pageVisible: boolean; plugins: WorkspacePlugin[] }
export function accessibleWorkspacePlugin(catalogue: WorkspacePluginCatalogue | null, section: string): WorkspacePlugin | undefined {
  if (!catalogue?.pageVisible) return undefined;
  return catalogue.plugins.find(plugin => `integrations/${plugin.id}` === section && plugin.enabled && plugin.capabilities.view);
}
export const WorkspacePluginService = {
  async catalogue(workspaceId: string): Promise<WorkspacePluginCatalogue> {
    const response = await fetch(`${SUPABASE_URL}/functions/v1/workspace-xero/workspaces/${encodeURIComponent(workspaceId)}/plugins`, { headers: await getAuthHeaders() });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Unable to load plugins');
    return data as WorkspacePluginCatalogue;
  },
};
